import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
var radioId = 0;
/**
 * `Radio` component is used for making a choice among a set of mutually exclusive, related options.
 * @since 3.2.0
 */

var Radio = function Radio(_ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "radio") : _ref$baseClassName,
      className = _ref.className,
      children = _ref.children,
      onChange = _ref.onChange,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      name = _ref.name,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "children", "onChange", "checked", "defaultChecked", "disabled", "name", "inputProps"]);

  var handleChange = function handleChange(event) {
    if (!disabled && onChange) {
      onChange(event.target.checked);
    }
  };

  var id = inputProps && inputProps.id || "radio-".concat(radioId++);
  return React.createElement("label", _extends({
    htmlFor: id,
    className: classNames(baseClassName, _defineProperty({}, "".concat(baseClassName, "--disabled"), disabled), className)
  }, props), React.createElement("input", _extends({
    className: "".concat(baseClassName, "__input"),
    type: "radio",
    name: name,
    id: id,
    onChange: handleChange,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled
  }, inputProps)), React.createElement("span", {
    className: "".concat(baseClassName, "__indicator")
  }), children ? React.createElement("span", {
    className: "".concat(baseClassName, "__text")
  }, children) : null);
};

export default Radio;